function loadUserInfo () {
  const userInfo = {}
  userInfo.user_name = localStorage.user_name
  userInfo.user_rights = localStorage.user_rights !== undefined ? localStorage.user_rights.split(',') : []
  userInfo.user_roles = localStorage.user_roles !== undefined ? localStorage.user_roles.split(',') : []
  return userInfo
}

const state = {
  logined: false,
  user_info: loadUserInfo(),
  mobile_verificat_time: 60,
  mobile_verificat_timer: null
}

const mutations = {
  setLogined (state, logined) {
    state.logined = logined
    state.user_info = loadUserInfo()
  },
  openTimeInterval (state) {
    if (state.mobile_verificat_timer) {
      clearInterval(state.mobile_verificat_timer)
      state.mobile_verificat_timer = null
    }
    state.mobile_verificat_time = 60
    state.mobile_verificat_timer = setInterval(() => {
      console.log('验证码时间-' + state.mobile_verificat_time)
      if (state.mobile_verificat_time <= 1) {
        clearInterval(state.mobile_verificat_timer)
        state.mobile_verificat_timer = null
      }
      state.mobile_verificat_time--
    }, 1000)
  },
  clearTimeInterval (state) {
    if (state.mobile_verificat_timer) {
      clearInterval(state.mobile_verificat_timer)
      state.mobile_verificat_timer = null
    }
  }
}
const actions = {
  loginSuccess (context) {
    context.commit('setLogined', true)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
